import { useSelector } from 'react-redux';
import { type Brands as BrandsType } from 'types/Brands';
import { currencyToSymbol } from 'utils/currencies';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  itemWrapper: {
    margin: '2px 0',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

type ItemProps = {
  title: string;
  isValidator: boolean;
  value: number;
  negativeValue?: boolean;
};

const Item = ({ title, isValidator, value, negativeValue }: ItemProps) => {
  const classes = useStyles();

  const currency = useSelector(
    ({ Brands }: { Brands: BrandsType }) => Brands.brand.multinational.currency
  );

  return (
    <div className={classes.itemWrapper}>
      <span>{title}</span>
      <span>
        {isValidator
          ? `${negativeValue ? '-' : ''}${(value || 0).toFixed(
              2
            )} ${currencyToSymbol(currency)}`
          : '-'}
      </span>
    </div>
  );
};

export default Item;
